export default __webpack_public_path__ + "static/media/OmnicureNowPlayStore.3f97ddc3.jpg";